import React, { useEffect, useMemo, useState } from "react";
import { Text } from "react-native";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { PasswordInput } from "../../components/PasswordInput";
import { CommonScreenCard } from "../../components/CommonScreenCard";
import useUniqueDispatch, {
  isLoading,
  useSelector,
} from "../../utils/redux-utils";
import { userResetPasswordAction } from "../../store/user/action";
import { RootState } from "../../store/root-reducer";
export const ResetPasswordPage = () => {
  const navigate = useNavigate();

  const [query] = useSearchParams();

  const code = useMemo(() => query.get("code"), [query]);

  useEffect(() => {
    if (!code) {
      navigate("/subscription/welcome");
    }
  }, [code]);

  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const match = useMemo(
    () => !!(repeatPassword && password === repeatPassword),
    [password, repeatPassword]
  );

  const disableButton = !match;

  const [resetPasswordToken, resetPassword] = useUniqueDispatch(
    userResetPasswordAction.request
  );

  const userState = useSelector((store: RootState) => store.user);

  const isResetting = isLoading(userState, resetPasswordToken);

  const onSubmit = () => {
    resetPassword([
      {
        code: code,
        password: password,
        passwordConfirmation: repeatPassword,
      },
    ]);
  };

  return (
    <CommonScreenCard>
      <Header onPressLeft={() => navigate("/subscription/welcome")} />
      <Text style={[fonts.title, { marginBottom: 8 }]}>New password</Text>
      <Text
        style={[fonts.mediumText_regular, { marginBottom: 29, maxWidth: 160 }]}
      >
        Create new password. Must contain symbols
      </Text>
      <PasswordInput
        containerStyle={{ marginBottom: 8 }}
        value={password}
        onChangeText={setPassword}
        matchNoText={match}
      />
      <PasswordInput
        containerStyle={{ height: 162 }}
        value={repeatPassword}
        onChangeText={setRepeatPassword}
        placeholder="Repeat password"
        match={match}
      />
      <CommonButton
        textStyle={fonts.mediumText_bold}
        title="Next"
        isLoading={isResetting}
        type={disableButton ? "black" : "blackFilled"}
        onPress={onSubmit}
        disabled={disableButton}
      />
    </CommonScreenCard>
  );
};
